import { FC } from 'react';
import NavigationLink from '../../utility/components/NavigationLink';

const PrivacyFooter: FC = () => {
  return (
    <div className='px-32 py-20 flex flex-row items-center justify-center lg:justify-end'>
      <NavigationLink
        dest='/privacy-policy'
        label='Privacy Policy'
        color='gray'
      />
    </div>
  );
};

export default PrivacyFooter;
